$(document).ready(function() {
  var dataResultPage = [];
  if ($('[diagnostic-resultats-json]').html()) {
    //dataResultPage = JSON.parse($('[diagnostic-resultats]').html());
    var jsonToParse = $('[diagnostic-resultats-json]').html().replace(/(\r\n|\n|\r)/gm,"");
    dataResultPage = JSON.parse(jsonToParse);
  }

  console.log(dataResultPage)

  var url = window.backend.url;

  $.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
      return null;
    }
    return decodeURI(results[1]) || 0;
  }

  var email = $.urlParam('email');

  $.ajax({
    type: "GET",
    url: `${url}diagnostic-beaute?email=${email}`,
    crossDomain: true,
    success: function(diag){
      console.log("RESULTAT CLIENT");
      console.log(diag)

      $('.first-name').html(diag.prenom)

      dataResultPage.casClient.forEach(function( carte ) {
        if (diag.casClient == carte.id) {
          $('.recommandation-top').html(carte.recommandation)

          $('#title_product').html(carte.produit_1.title)

          $.ajax({
              type: 'GET',
              url: `https://${ window.location.hostname }/products/${ carte.produit_1 }/?section_id=product-grid-diag`,
              success: function(data) {
                $('.product_1_diag').append(data);
              },
              error: function(error) {
                console.log('erreur')
                console.log(error)
              }
          });
          $.ajax({
              type: 'GET',
              url: `https://${ window.location.hostname }/products/${ carte.produit_2 }/?section_id=product-grid-diag`,
              success: function(data) {
                $('.product_2_diag').append(data);
              },
              error: function(error) {
                console.log('erreur')
                console.log(error)
              }
          });
          $.ajax({
              type: 'GET',
              url: `https://${ window.location.hostname }/products/${ carte.produit_3 }/?section_id=product-grid-diag`,
              success: function(data) {
                $('.product_3_diag').append(data);
              },
              error: function(error) {
                console.log('erreur')
                console.log(error)
              }
          });
          $.ajax({
              type: 'GET',
              url: `https://${ window.location.hostname }/products/${ carte.produit_4 }/?section_id=product-grid-diag`,
              success: function(data) {
                $('.product_4_diag').append(data);
              },
              error: function(error) {
                console.log('erreur')
                console.log(error)
              }
          });

          $('.image_picto_1').attr('src', carte.problematique_1_picto)
          $('.title_picto_1').html(carte.problematique_1_titre)
          $('.text_picto_1').html(carte.problematique_1_texte)

          if (carte.problematique_2_picto) {
            $('.image_picto_2').attr('src', carte.problematique_2_picto)
            $('.title_picto_2').html(carte.problematique_2_titre)
            $('.text_picto_2').html(carte.problematique_2_texte)
          } else {
            $('#preo_2').hide()
          }
        }
      });

      dataResultPage.galenique.forEach(function( carte ) {
        if (diag.casClient.indexOf(carte.id) > -1) {
          console.log(carte)
          $('.galenique_picto').attr('src', carte.picto)
          $('.galenique_title').html(carte.titre)
          $('.galenique_text').html(carte.texte)
        }
      });

      dataResultPage.habitude_complements.forEach(function( carte ) {
        if (diag.habitude_complements == carte.id) {
          $('.complement_picto').attr('src', carte.picto)
          $('.complement_title').html(carte.titre)
          $('.complement_text').html(carte.texte)
        }
      });

      dataResultPage.sport.forEach(function( carte ) {
        if (diag.sport == carte.id) {
          $('.sport_picto').attr('src', carte.picto)
          $('.sport_title').html(carte.titre)
          $('.sport_text').html(carte.texte)
        }
      });

      dataResultPage.alimentation.forEach(function( carte ) {
        if (diag.alimentation == carte.id) {
          $('.alimentation_picto').attr('src', carte.picto)
          $('.alimentation_title').html(carte.titre)
          $('.alimentation_text').html(carte.texte)
        }
      });

    },
    error: function(error){
      console.log("error occurred.");
      console.log(error)
      var error = error.responseJSON.error;
      // window.location.href = "/pages/diagnostic-beaute";
      console.log(error)
    }
  });


  var handleCartePeau = function(carte, diag) {
    $('#carte_de_peau_type').html(carte.titre);
    $('#carte_de_peau_tendance').html(carte.sous_titre);
    $('#carte_de_peau_caractéristique').html(carte.caracteristiques);
    $('#carte_de_peau_tendance2').html(carte.tendances);
    if (diag.preo_visage_front != '') {
      $('#carte_de_peau_preoccupation').html(diag.preo_visage_front)
    } else {
      $('#preoccupation_visage').hide()
      $('#preoccupation_choix').hide()
    }
    $('#carte_de_peau_recommandation').html(carte.recommandations);
  }

  var handleTitreGeste = function(carte){
    $('#geste_essentiel_type_peau').html(carte.titre)
  }

  var variantGeste = [];

  var handleGeste = function( carte, i ){
    $('#geste_essentiel_titre_'+ i).html(carte.titre);
    $('#geste_essentiel_pourquoi_'+ i).html(carte.pourquoi);
    $('#geste_essentiel_comment_'+ i).html(carte.comment);
    $('#geste_essentiel_product_type_'+ i).html(carte.sur_titre)
    $('#geste_essentiel_product_button_'+ i).attr('variant-id', carte.variant_id);

    $('#prescription_product_type_'+ i +'_geste').html(carte.sur_titre)
    $('#prescription_checkbox_'+ i +'_geste').attr('variant_id', carte.variant_id);

    variantGeste.push(carte.variant_id)

    var productNettoyant = carte.product
    $.getJSON('/products/'+ productNettoyant + '.js', function(product) {

      $('#geste_essentiel_product_title_'+ i).html(product.title)
      var priceProduct = product.variants[0].price / 100
      var finalPrice = priceProduct.toFixed(2) + "€"
      $('#geste_essentiel_product_price_'+ i).html(finalPrice)
      $('#geste_essentiel_product_image_'+ i).attr('src', product.images[0]);

      $('#geste_essentiel_product_button_'+ i).attr('product-handle', product.handle);
      $('#geste_essentiel_product_button_'+ i).attr('variant-available', product.available);
      if (product.available == true) {
        $('#geste_essentiel_product_button_'+ i +'_rupture').hide()
        $('#geste_essentiel_product_button_'+ i).show()
      } else {
        $('#geste_essentiel_product_button_'+ i +'_rupture').show()
        $('#geste_essentiel_product_button_'+ i).hide()
      }

      $('#prescription_product_image_'+ i +'_geste').attr('src', product.images[0]);
      $('#prescription_product_title_'+ i +'_geste').html(product.title)
      $('#prescription_product_price_'+ i +'_geste').html(finalPrice)
      $('#prescription_checkbox_'+ i +'_geste').attr('price', product.variants[0].price);

    });
  }

  var handleConseilPeau = function(carte){
    $('#geste_essentiel_conseil_type_peau').html(carte.titre)
    $('#geste_essentiel_conseil_peau').html(carte.conseils)
  }

  var handleConseilHydratation = function(carte){
    $('#geste_essentiel_conseil_deshydratation').html(carte.texte)
  }

  var handleConseilFragilite = function(carte){
    $('#geste_essentiel_conseil_fragile').html(carte.texte)
  }

  var variantPreoVisage = [];
  var variantPreoCorps = [];

  var handlePreo = function(carte, i, type){
    var preo_result = function(i){

      $('#preoccupation_'+ i +'_title'+ type).html(carte.titre)
      $('#preoccupation_'+ i +'_source'+ type).html(carte.source_1)
      $('#preoccupation_'+ i +'_vie'+ type).html(carte.dans_la_vie)
      $('#preoccupation_'+ i +'_assiette'+ type).html(carte.dans_lassiette)
      $('#preoccupation_'+ i +'_soin'+ type).html(carte.dans_vos_soins)
      $('#preoccupation_'+ i +'_product_type'+ type).html(carte.sur_titre)
      $('#preoccupation_'+ i +'_product_button'+ type).attr('variant-id', carte.variant_id);


      if ($.inArray(carte.variant_id, variantGeste) != -1 && type == '') {

      } else if ($.inArray(carte.variant_id, variantPreoVisage) != -1 && type == ''){

      } else if ($.inArray(carte.variant_id, variantPreoCorps) != -1 && type == '_corps'){

      } else {
        $('#prescription_product_type_'+ i + type).html(carte.sur_titre)
        $('#prescription_checkbox_'+ i + type).attr('variant_id', carte.variant_id)
      }



      var productPreo1 = carte.product
      $.getJSON('/products/'+ productPreo1 + '.js', function(product) {

        $('#preoccupation_'+ i +'_product_title'+ type).html(product.title)
        var priceProduct = product.variants[0].price / 100
        var finalPrice = priceProduct.toFixed(2) + "€"
        $('#preoccupation_'+ i +'_product_price'+ type).html(finalPrice)
        $('#preoccupation_'+ i +'_product_image'+ type).attr('src', product.images[0]);

        $('#preoccupation_'+ i +'_product_button'+ type).attr('product-handle', product.handle);
        $('#preoccupation_'+ i +'_product_button'+ type).attr('variant-available', product.available);
        if (product.available == true) {
          $('#preoccupation_'+ i +'_product_button'+ type +'_rupture').hide()
          $('#preoccupation_'+ i +'_product_button'+ type).show()
        } else {
          $('#preoccupation_'+ i +'_product_button'+ type +'_rupture').show()
          $('#preoccupation_'+ i +'_product_button'+ type).hide()
        }

        if ($.inArray(carte.variant_id, variantGeste) != -1 && type == '') {
          $('#product_'+ i ).hide()
        } else if ($.inArray(carte.variant_id, variantPreoVisage) != -1 && type == '') {
          $('#product_'+ i ).hide()
        } else if ($.inArray(carte.variant_id, variantPreoCorps) != -1 && type == '_corps'){
          $('#product_'+ i +'_corps').hide()
        } else {
          $('#prescription_product_image_'+ i + type).attr('src', product.images[0]);
          $('#prescription_product_title_'+ i + type).html(product.title)
          $('#prescription_product_price_'+ i + type).html(finalPrice)
          $('#prescription_checkbox_'+ i + type).attr('price', product.variants[0].price)
        }

        if (type == '') {
          variantPreoVisage.push(carte.variant_id)
        }
        if(type == '_corps'){
          variantPreoCorps.push(carte.variant_id)
        }
      });

    }
    if (i == 1) {
      preo_result(i)
    } else if (i == 2){
      preo_result(i)
    } else if (i == 3){
      preo_result(i)
    }
  }

  if (window.matchMedia("(max-width: 767px)" ).matches) {
    $('#sommaire_diag_visage').on('click', function(){
      $('.choix-visage').css('display', 'block');
      console.log('passe')
    })
  } else {
    $( ".choix-visage" ).mouseleave(function() {
      $('.choix-visage').css('display', 'none');
    });
    $('#sommaire_diag_visage').hover(function(){
      $('.choix-visage').css('display', 'block');
    })
  }

  $('#sommaire_diag_visage').on('click', function(){
    $('#diagnostic-visage').show()
    $('#diagnostic-corps').hide()
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  })
  $('#sommaire_diag_corps').on('click', function(){
    $('#diagnostic-visage').hide()
    $('#diagnostic-corps').show()
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  })

  $('.choix-visage .choix').on('click', function(){
    $('#diagnostic-visage').show()
    $('#diagnostic-corps').hide()
    var partie = $(this).attr('partie');
    $('html, body').animate({
      scrollTop: $(partie).offset().top - 120
    }, 500);
    $('.choix-visage').css('display', 'none');
  })

  $(document).on('click', function(e){
    var container = $(".choix-visage");
    var container2 = $("#sommaire_diag_visage");
    if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
      $('.choix-visage').css('display', 'none');
    }
  });

  var price_product = '';
  var price_product_corps = '';

  $('.product-visage').on('click', function() {
    $(this).children('.visage--box').children('.icon--validate').toggleClass('display__none checked');
  })
  $('.product-corps').on('click', function() {
    $(this).children('.corps--box').children('.icon--validate').toggleClass('display__none checked');
  })

  $('.product-visage').click(function(){
    if($(this).children('.visage--box').children('.icon--validate').hasClass('checked')){
      price_product = Number(price_product) + Number($(this).children('.visage--box').attr('price'));
      var divided = price_product / 100
      var finalPrice = "- " + divided.toFixed(2) + "€"

      if (finalPrice != '- 0.00€') {
        $('.text-add-product').html('Ajouter au panier')
        $('.price-all-product').show().css('margin-left', '6px')
        $('.price-all-product').html(finalPrice)
      } else {
        $('.text-add-product').html('Choisir des produits');
      }

    }
    else {
      price_product = Number(price_product) - Number($(this).children('.visage--box').attr('price'));
      var divided = price_product / 100;
      var finalPrice = "- " + divided.toFixed(2) + "€"

      if (finalPrice == '- 0.00€') {
        $('.price-all-product').hide()
        $('.text-add-product').html('Choisissez des produits');
      } else {
        $('.price-all-product').html(finalPrice)
        $('.text-add-product').html('Ajouter au panier')
      }
    }
  });


  $('.product-corps').click(function(){
    if($(this).children('.corps--box').children('.icon--validate').hasClass('checked')){
      price_product_corps = Number(price_product_corps) + Number($(this).children('.corps--box').attr('price'));
      var divided = price_product_corps / 100
      var finalPrice = "- " + divided.toFixed(2) + "€"

      if (finalPrice != '- 0.00€') {
        $('.text-add-product_corps').html('Ajouter au panier')
        $('.price-all-product_corps').show().css('margin-left', '6px')
        $('.price-all-product_corps').html(finalPrice)
      } else {
        $('.text-add-product_corps').html('Choisir des produits');
      }
    }
    else {
      price_product_corps = Number(price_product_corps) - Number($(this).children('.corps--box').attr('price'));
      var divided = price_product_corps / 100;
      var finalPrice = "- " + divided.toFixed(2) + "€"

      if (finalPrice == '- 0.00€') {
        $('.price-all-product_corps').hide()
        $('.text-add-product_corps').html('Choisissez des produits');
      } else {
        $('.price-all-product_corps').html(finalPrice)
        $('.text-add-product_corps').html('Ajouter au panier')
      }
    }
  });


  var sendCart = function(type){
    var data = {updates: {}};

    $(type).each(function(){
      var variantId = $(this).attr('variant_id')
      if (variantId && $(this).is(':visible')) {
        if ($(this).children('.icon--validate').hasClass('checked')) {
          data.updates[variantId] =  1;
        } else {
          data.updates[variantId] =  0;
        }
      }
    })
    console.log(data)
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(response) {
        console.log(response)
        document.dispatchEvent(new CustomEvent('addToCart'));
      },
      error: function(error) {
        console.log(error)
        console.log('erreur');
      }
    });
  }

  $('.button-add-cart--prescription').on('click', function(){
    sendCart('.visage--box')
  })
  $('.button-add-cart--prescription_corps').on('click', function(){
    sendCart('.corps--box')
  })


})
